import { type HttpClient } from '@/application/interfaces/http-client';

import { getCategoriesMap } from './get-categories-map';
import { getProductsMap } from './get-products-map';

const SiteMapServices = (httpClient: HttpClient.Instance) => ({
  getCategoriesMap: getCategoriesMap(httpClient),
  getProductsMap: getProductsMap(httpClient),
});

export default SiteMapServices;
